import { useEffect, useState } from 'react'
import { prettyLog } from '../../../utils'

const useGeoManifestFetch = () => {
  const [isIsrael, setIsIsrael] = useState<'Israel' | 'Not Israel' | false>(
    false
  )
  useEffect(() => {
    fetch(
      'https://d18b0e6mopany4.cloudfront.net/out/v1/1a7c55961dec4c72b51d79e5d9216cff/index.m3u8'
    )
      .then(res => {
        setIsIsrael(res.status === 200 ? 'Israel' : 'Not Israel')
      })
      .catch(res => {
        prettyLog('useGeoManifestFetch: 11', res, 'error')
        setIsIsrael('Not Israel')
      })
  }, [])
  return isIsrael
}
export default useGeoManifestFetch
